import axios from 'axios';
import { clearClientSessionData } from '../utils/clearClientSessionData';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000/dev').trim();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// On 401 (token expired/invalid), wipe client session and dispatch event for AuthContext to log out
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Don't trigger logout for login/register - those 401s are "invalid credentials"
      if (!url.includes('/auth/login') && !url.includes('/auth/register')) {
        clearClientSessionData();
        delete api.defaults.headers.common['Authorization'];
        sessionStorage.setItem('sessionExpired', 'true');
        window.dispatchEvent(new CustomEvent('auth:session-expired'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;

